import { RouteType } from "types/RouteType";

/**
 * LNI Codes Route
 * Manage Labor & Industries codes for Washington State workers compensation
 *
 * KEY FEATURES:
 * - Add/edit/remove LNI codes (Titan doesn't allow removal)
 * - Assign LNI codes to employees with primary/temporary designation
 * - Support for off-site work codes with auto-hour calculation
 */
export const lniCodesRoute: RouteType = {
  name: "LNI Codes",
  path: "/payroll/admin/lni-codes",
  layout: "/app",
  viewportCard: {
    header: {
      title: "LNI Codes",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./LNICodes.Header"),
    },
    body: {
      component: () => import("./LNICodes.Body"),
      grayBackground: true,
    },
  },
  dialogs: [
    {
      name: "LNICodeDialog",
      title: "LNI Code",
      component: () => import("./LNICodeDialog"),
    },
    {
      name: "LNIAssignmentDialog",
      title: "LNI Assignment",
      component: () => import("./LNIAssignmentDialog"),
    },
  ],
  group: "Payroll Admin",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async () => {
    return true;
  },
};

export default [lniCodesRoute];
